// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__E5udt","contentWrapper":"styles_contentWrapper__q7gjs","main":"styles_main__uh0zS"};